import { createActionTypes } from "@helpers/redux-helpers";

export const getSubscriptionActionTypes =
  createActionTypes("subscriptions/get");

export const getSubscriptionsByPostActionTypes = createActionTypes(
  "subscriptions/byPost",
);

export const getPortionSubscriptionActionTypes = createActionTypes(
  "subscriptions/getPortion",
);

export const createSubscriptionActionTypes = createActionTypes(
  "subscriptions/create",
);

export const editSubscriptionActionTypes =
  createActionTypes("subscriptions/edit");

export const setPaymentSubscriptionsActionTypes =
  createActionTypes("subscriptions/set");

export const setPaymentSubscriptionsPortionActionTypes = createActionTypes(
  "subscriptions/setPortion",
);

export const getSubscriptionDetailsActionTypes = createActionTypes(
  "subscriptions/getDetails",
);

export const deleteMySubscriptionActionTypes = createActionTypes(
  "profile/subscription/delete",
);

export const changeSubscriptionPositionActionTypes = createActionTypes(
  "subscriptions/changePosition",
);

export const updateSubscriptionsActionTypes = "subscriptions/update";
